import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {
  Hort360DefinitionCatchment,
  Hort360DefinitionStates,
  Hort360PropertySummary
} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {RSValidatorFormDirective} from '../../../libs/rsvalidator/rsvalidator.directive';
import {DataService} from '../../services/data.service';
import {ReplaySubject} from 'rxjs';
import {AvailableIcon} from '../../services/icons.service';

@Component({
  selector: 'app-update-property-contact',
  templateUrl: './update-property-contact.component.html',
  styleUrls: ['./update-property-contact.component.scss']
})
export class UpdatePropertyContactComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;

  otherProperty: Hort360PropertySummary = {} as Hort360PropertySummary;

  public filteredItems: ReplaySubject<Hort360DefinitionCatchment[]> = new ReplaySubject<Hort360DefinitionCatchment[]>(1);
  public searchText = '';

  public catchments: Hort360DefinitionCatchment[] = [];
  public states: Hort360DefinitionStates[] = [];
  public stateObjects: {[key: string]: Hort360DefinitionStates} = {};

  constructor(public dataService$: DataService) {
    super();

    const globals = this.dataService$.globals.getValue();
    this.catchments = globals.catchments || [];
    this.catchments = this.catchments.sort((a, b) => (a.state + a.groupname + a.name).localeCompare(b.state + b.groupname + b.name));
    this.states = globals.states || [];
    this.stateObjects = {};
    this.states.forEach(s => this.stateObjects[s.id] = s);

    this.filterItems();
  }

  ngOnInit(): void {
    // Wait for input
    this.otherProperty = Object.assign({}, (this.dialogValues?.other || {})) as Hort360PropertySummary;
    this.dialogValuesUpdated.subscribe(v => {
      this.otherProperty = Object.assign({}, (v.other || {})) as Hort360PropertySummary;
    });
  }

  ngAfterViewInit() {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  ngOnDestroy() { }

  close(state: number | undefined | boolean = RSDialog.defaultValues.CANCEL) {
    this.dialogHandles.close(state);
  }

  saveOther() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.dialogValues.other = this.otherProperty;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

  filterItems() {
    // get the search keyword
    let search = this.searchText;
    if (!search) {
      this.filteredItems.next(this.catchments);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredItems.next(
      this.catchments.filter(
        catchment => (
                    (catchment.name + '').toLowerCase() + ' ' +
                    (catchment.groupname + '').toLowerCase() + ' ' +
                    (this.stateObjects[catchment.state]?.name + '')
        ).indexOf(search) > -1
      )
    );

  }

}
